import { Dialog, DialogContent, DialogTitle, DialogContentText, LinearProgress, Box } from "@mui/material";

export default function DownloadProgressDialog({
    open,
    message,
    completed,
    total
}) {
    const hasProgress = Number.isFinite(total) && total > 0 && Number.isFinite(completed);
    const percent = hasProgress ? Math.min(100, Math.round((completed / total) * 100)) : 0;

    return (
        <Dialog open={open} aria-labelledby="alert-dialog-title">
            <DialogTitle id="alert-dialog-title">{message}</DialogTitle>
            <DialogContent>
                <Box sx={{ width: '100%', minWidth: 300 }}>
                    {hasProgress ? (
                        <>
                            <LinearProgress
                                variant="determinate"
                                value={percent}
                                aria-label="Download progress"
                                aria-valuenow={percent}
                            />
                            <DialogContentText sx={{ mt: 1, textAlign: "center" }}>
                                {`${completed} of ${total} completed`}
                            </DialogContentText>
                        </>
                    ) : (
                        <LinearProgress aria-label="Download progress" />
                    )}
                </Box>
            </DialogContent>
        </Dialog>
    )
}
